import React from "react";
import styles from "./TariffTable.module.scss";
import TariffItem from "./TariffItem";

interface TariffItem {
    title: string;
    text?: string;
    value?: string;
}

interface TariffTableProps {
    table: TariffItem[];
}

const TariffTable: React.FC<TariffTableProps> = ({table}) => {
    return (
        <div className={styles.tariffTable}>
            {table.map((item, index) => (
                <TariffItem key={index} title={item.title} text={item.text} value={item.value}/>
            ))}
        </div>
    )
}
export default TariffTable;